'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');

var HelpButton = React.createClass({
  render: function () {
    return (
      <div>
        <img src={assetsHelper.getComponentAsset('helpButton')}/>
      </div>
    )
  }
});

module.exports = HelpButton;



// WEBPACK FOOTER //
// ./src/views/Components/HelpButton.jsx